import styled from 'styled-components';
import { colors } from '@/styles';

export const FileInfoGrid = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-auto-columns: auto;
  grid-gap: 1px;
  overflow: hidden;
  background: ${colors.secondary.lightGray2};

  /* max-width: 500px; */

  & > .row {
    padding: 5px;
    display: grid;
    background: ${colors.primary.white};
    column-gap: 10px;
    align-items: center;
    grid-template-columns: 100px auto 100px 20px;

    &:hover {
      background: ${colors.secondary.lightGray1};
    }
    & > * {
      /* background: ${colors.primary.white}; */
      white-space: nowrap;
      &.data-type {
      }
      &.filename {
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &.file-size {
        text-align: right;
      }
      &.file-remove {
        text-align: center;
        color: ${colors.semantic.negative.dark};
        cursor: pointer;
        &:hover {
          color: ${colors.semantic.negative.primary};
        }
      }
    }
  }
`;
